import Deserializer from '~/services/Deserializer'
import REF from '~/services/REF'
import { AppThunk } from '~/state/store'
import ErrorHandler from '~/utils/errorHandler'

import { STATUSES } from '~/constants/statuses'

import {
  cancelReferral,
  failure,
  request,
  success,
  successItem
} from './referrals.slice'

/**
 * Get referrals action
 */
export const getReferrals = (
  params: QueryParams,
  isLoading?: boolean
): AppThunk<Promise<void>> => async (dispatch): Promise<void> => {
  if (!isLoading) {
    dispatch(request())
  }

  const filterConfig = {
    page: 'page',
    status: 'by_status',
    search_query: 'by_search',
    by_order: 'by_order'
  }

  const normalizedParams = Object.entries(params as QueryParams).reduce<
    QueryParams
  >((acc, [key, value]) => {
    const newKey = filterConfig[key]

    if (key === 'by_order') {
      acc[newKey] = { field: value[0], direction: value[1] }
    } else if (key === 'status') {
      if (value === 'new') {
        acc[newKey] = 'new_referrals'
      } else if (value === 'completed') {
        acc[newKey] = 'completed_referrals'
      } else if (value === 'scheduled') {
        acc[newKey] = 'scheduled_referrals'
      } else {
        acc[newKey] = value
      }
    } else {
      acc[newKey] = value
    }

    return acc
  }, {} as OrderQueryDTO)

  try {
    const { referrals, pagy } = await REF.getReferrals(normalizedParams)
    const payload = await Deserializer.deserialize(referrals)

    dispatch(
      success({
        data: payload,
        meta: {
          count: pagy.count,
          pages: pagy.pages,
          page: pagy.page
        }
      })
    )
  } catch (error) {
    dispatch(failure(true))
    throw new ErrorHandler(error)
  }
}

/**
 * Get referral action
 */
export const getReferralById = (
  id: string,
  router?: any
): AppThunk<Promise<void>> => async (dispatch): Promise<void> => {
  dispatch(request())

  try {
    const response = await REF.getReferralById(id)
    // @ts-ignore
    if (!response.data && !!router) {
      router()
    } else {
      const data = await Deserializer.deserialize(response)

      dispatch(successItem(data))
    }
  } catch (error) {
    throw new ErrorHandler(error)
  }
}

/**
 * Update referral action
 */
export const updateReferralById = (
  id: string,
  values: ReferralDTO
): AppThunk<Promise<void>> => async (dispatch): Promise<void> => {
  dispatch(request())

  try {
    const response = await REF.updateReferralById(id, values)
    const data = await Deserializer.deserialize(response)

    dispatch(successItem(data))
  } catch (error) {
    throw new ErrorHandler(error)
  }
}

/**
 * Cancel referral action
 */
export const cancelReferralById = (
  id: string,
  comment?: string,
  date?: string
): AppThunk<Promise<void>> => async (dispatch): Promise<void> => {
  try {
    await REF.updateReferralById(id, {
      status: STATUSES.canceled,
      refusal_comment: comment,
      canceled_at: date
    })

    dispatch(cancelReferral(id))
  } catch (error) {
    throw new ErrorHandler(error)
  }
}

/**
 * Create referral action
 */
export const createReferral = (
  values: ReferralDTO
): AppThunk<Promise<void>> => async (dispatch): Promise<void> => {
  try {
    const res = await REF.createReferral(values)
    const payload = await Deserializer.deserialize(res)

    dispatch(successItem(payload))
  } catch (error) {
    throw new ErrorHandler(error)
  }
}
